import moment from 'moment'
import { WizClassifySelect } from '@/containers/common';
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      title: "课程名称",
      name: "name",
      dataIndex: "name",
      tableItem: {
        width: 200
      },
      searchItem: {
      },
    },
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "课程编码",
      name: "scoId",
      dataIndex: "scoId",
      tableItem: {
        width: 220
      },
      searchItem: {},
    },
    {
      title: "课程分类",
      name: "programCategoryIds",
      dataIndex: "programCategoryIds",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          checkable: true,
          itemProps: {
            icon: 'unordered-list',
            title: '课程分类',
            tips: '请勾选所属课程分类'
          },
          treeProps: { checkStrictly: true }
        },
        apiProps: { type: 1 },
        selectProps: {
          placeholder: '请选择课程分类'
        },
      },
    },
    {
      title: "课程分类",
      name: "programCategoryNames",
      dataIndex: "programCategoryNames",
      tableItem: {
        width: 220
      }
    },
    {
      title: "课程来源",
      name: "programSource",
      dataIndex: "programSource",
      searchItem: {
        type: "select"
      },
      dict: [
        { code: 1, codeName: "别克销售" },
        { code: 2, codeName: "雪佛兰销售" },
        { code: 3, codeName: "凯迪拉克销售" },
        { code: 4, codeName: "售后技术" },
        { code: 5, codeName: "售后非技术" },
        { code: 6, codeName: "二手车" },
        { code: 8, codeName: "集团销售" },
        { code: 9, codeName: "校企合作" },
        { code: 10, codeName: "融入辅导_相达" },
        { code: 11, codeName: "融入辅导_申先" },
        { code: 12, codeName: "TAC技术支持" },
        { code: 13, codeName: "其它" },
        { code: 14, codeName: "车工坊" },
        { code: 15, codeName: "德科" },
      ],
    },
    {
      title: "课程来源",
      name: "programSource",
      dataIndex: "programSource",
      tableItem: {},
      dict:[
        { code: 1, codeName: "别克销售" },
        { code: 2, codeName: "雪佛兰销售" },
        { code: 3, codeName: "凯迪拉克销售" },
        { code: 4, codeName: "售后技术" },
        { code: 5, codeName: "售后非技术" },
        { code: 6, codeName: "二手车" },
        { code: 7, codeName: "凯迪新能源" },
        { code: 8, codeName: "集团销售" },
        { code: 9, codeName: "校企合作" },
        { code: 10, codeName: "融入辅导_相达" },
        { code: 11, codeName: "融入辅导_申先" },
        { code: 12, codeName: "TAC技术支持" },
        { code: 13, codeName: "其它" },
        { code: 14, codeName: "车工坊" },
        { code: 15, codeName: "德科" },
        { code: 19, codeName: "别克新能源"}
      ],
    },
    {
      title: "课程时间",
      name: "programDate",
      dataIndex: "programDate",
      tableItem: {
        width: 300,
        render: (text, record) => {
          const { startDate, endDate } = record;
          const programDate = formatterDate(startDate) + " ~" + formatterDate(endDate);
          return programDate
        }
      },
      searchItem: {
        type: 'date~',
        showTime: false,
        format: 'YYYY-MM-DD'
      },
    }

  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'program/getListByPage',
    ...api
  }
}

const program = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(),
    tableApi: tableApi(api),
    searchProps: {
      dataFormat: (v) => {
        let value = Object.assign([], v)
        if (value['programDate'] && value['programDate'].length === 2) {
          value['startDate'] = moment(value['programDate'][0]).format("YYYY-MM-DD HH:mm:00")
          value['endDate'] = moment(value['programDate'][1]).format("YYYY-MM-DD HH:mm:59")
        }
        delete value['programDate']

        return value
      }
    },
  }
}

export default program
